module.exports = __webpack_public_path__ + "static/media/baseline-cloud_upload-24px.3f7e59cc.svg";